import React, { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Banner from "../components/Banner";
import BackToTop from "../components/BackToTop";
import { WOW } from "wowjs";
import "../css/global.css";
import "../css/PrivacyPolicy.css";

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    const wow = new WOW({
      live: false,
    });
    wow.init();
  }, []);

  return (
    <div className="privacy-policy-page">
      <Header />

      <Banner
        backgroundImage="/wp-content/uploads/2016/02/privacy-policy.jpg"
        title="Privacy Policy"
      />

      <section className="contentwrapper clearfix">
        <div className="content clearfix">
          <div className="breadcrumbs">
            <a href="/">Home</a> &gt; <span>Privacy Policy</span>
          </div>

          <h1 className="wow fadeInDown" data-aos="fade-right">
            Privacy Policy
          </h1>

          <div
            className="policy-content wow fadeInUp"
            data-wow-delay="0.2s"
            data-aos="fade-up"
          >
            <p>
              <strong>
                This privacy policy sets out how Colombo Dockyard PLC (Colombo
                Dockyard) uses and protects any information that you give
                Colombo Dockyard when you use this website.
              </strong>
            </p>
            <p>
              Colombo Dockyard is committed to ensuring that your privacy is
              protected. Should we ask you to provide certain information by
              which you can be identified when using this website, then you can
              be assured that it will only be used in accordance with this
              privacy statement.
            </p>
            <p>
              Colombo Dockyard may change this policy from time to time by
              updating this page. You should check this page often to ensure
              that you are happy with any changes. This policy is effective from
              January 1st 2011.
            </p>

            <p>
              <strong>What we collect</strong>
            </p>
            <p>We may collect the following information</p>
            <ul>
              <li>name and job title</li>
              <li>contact information including email address</li>
              <li>
                demographic information such as postcode, preferences and
                interests
              </li>
              <li>
                other information relevant to customer surveys and/or offers
              </li>
            </ul>

            <p>
              <strong>What we do with the information we gather</strong>
            </p>
            <p>
              We require this information to understand your needs and provide
              you with a better service, and in particular for the following
              reasons:
            </p>
            <ul>
              <li>Internal record keeping</li>
              <li>
                We may use the information to improve our service offerings
              </li>
              <li>
                From time to time, we may also use your information to contact
                you for market research purposes. We may contact you by email,
                phone, fax or mail. We may use the information to customise the
                website according to your interests
              </li>
            </ul>

            <p>
              <strong>Security</strong>
            </p>
            <p>
              We are committed to ensuring that your information is secure. In
              order to prevent unauthorised access or disclosure, we have put in
              place suitable physical, electronic and managerial procedures to
              safeguard and secure the information we collect online.
            </p>

            <p>
              <strong>How we use cookies</strong>
            </p>
            <p>
              A cookie is a small file which asks permission to be placed on
              your computer’s hard drive. Once you agree, the file is added and
              the cookie helps analyse web traffic or lets you know when you
              visit a particular site. Cookies allow web applications to respond
              to you as an individual. The web application can tailor its
              operations to your needs, likes and dislikes by gathering and
              remembering information about your preferences.
            </p>
            <p>
              We use traffic log cookies to identify which pages are being used.
              This helps us analyse data about web page traffic and improve our
              website in order to tailor it to customer needs. We only use this
              information for statistical analysis purposes and then the data is
              removed from the system.
            </p>
            <p>
              Overall, cookies help us provide you with a better website by
              enabling us to monitor which pages you find useful and which you
              do not. A cookie in no way gives us access to your computer or any
              information about you, other than the data you choose to share
              with us.
            </p>
            <p>
              You can choose to accept or decline cookies. Most web browsers
              automatically accept cookies, but you can usually modify your
              browser setting to decline cookies if you prefer. This may prevent
              you from taking full advantage of the website.
            </p>

            <p>
              <strong>Links to other websites</strong>
            </p>
            <p>
              Our website may contain links to other websites of interest.
              However, once you have used these links to leave our site, you
              should note that we do not have any control over that other
              website. Therefore, we cannot be responsible for the protection
              and privacy of any information which you provide whilst visiting
              such sites and such sites are not governed by this privacy
              statement. You should exercise caution and look at the privacy
              statement applicable to the website in question.
            </p>

            <p>
              <strong>Controlling your personal information</strong>
            </p>
            <p>
              You may choose to restrict the collection or use of your personal
              information in the following ways:
            </p>
            <ul>
              <li>
                whenever you are asked to fill in a form on the website, look
                for the box that you can click to indicate that you do not want
                the information to be used by anybody for direct marketing
                purposes
              </li>
              <li>
                if you have previously agreed to us using your personal
                information for direct marketing purposes, you may change your
                mind at any time by writing to or emailing us at:{" "}
                <strong>coldock@cdl.lk</strong>
              </li>
            </ul>

            <p>
              We will not sell, distribute or lease your personal information to
              third parties unless we have your permission or are required by
              law to do so. We may use your personal information to send you
              promotional information about third parties which we think you may
              find interesting if you tell us that you wish this to happen.
            </p>
            <p>
              If you believe that any information we are holding on you is
              incorrect or incomplete, please email us as soon as possible at
              the above address. We will promptly correct any information found
              to be incorrect.
            </p>
          </div>
        </div>
      </section>

      <Footer />
      <BackToTop />
    </div>
  );
};

export default PrivacyPolicy;
